import { languageOptions } from '@/src/constants/header'

export const getLanguageByCode = (code: string) => {
    const langOption = languageOptions.find(l => l.code === code)
    return langOption || languageOptions[0]
}

export const switchLocaleInPath = (
    currentPath: string,
    currentSearch: string,
    currentHash: string,
    newLocaleCode: string
) => {
    let newPath = currentPath
    if (currentPath.startsWith('/en')) {
        newPath = newLocaleCode === 'ar' ? currentPath.replace(/^\/en/, '/ar') : currentPath
    } else if (currentPath.startsWith('/ar')) {
        newPath = newLocaleCode === 'en' ? currentPath.replace(/^\/ar/, '/en') : currentPath
    } else {
        // If no locale in path, add it
        newPath = `/${newLocaleCode}${currentPath}`
    }
    return newPath + currentSearch + currentHash
}
